'use strict';

var novicell = novicell || {};
let sliderPlayers = [];
let YT;

novicell.sliderSpot = novicell.sliderSpot || new function () {

  this.init = function () {
    const elements = document.querySelectorAll('.js-slider-spot');
    if (elements.length) {
      for (let i = 0; i < elements.length; i++) {
        let sliderActive = false;
        if (elements[i].classList.contains('js-slider-spot-slider')) {
          let flkty = new Flickity(elements[i], {
            // options
            cellAlign: 'left',
            contain: true,
            autoPlay: (typeof elements[i].dataset.sliderAutoplay !== 'undefined' ? 5000 : false),
            arrowShape: {
              x0: 10,
              x1: 60, y1: 50,
              x2: 65, y2: 45,
              x3: 20
            }
          });
          sliderActive = true;
          flkty.on('select', function () {
            novicell.sliderSpot.pauseAllVideos(flkty, elements[i]);
            novicell.sliderSpot.checkIfVideoIsInViewPort(elements[i], sliderActive, false);
          });
        } else {
          let caption = elements[i].querySelector('.js-slider-spot-caption');
          if (caption) {
            caption.parentNode.parentNode.parentNode.appendChild(caption);
            caption.classList.add('slider-spot__caption--under-picture');
          }
        }
        // Checking if we have a element, and then play video if we have it in our viewport
        let video = novicell.sliderSpot.checkIfVideoIsInViewPort(elements[i], sliderActive, true);
        if (video) {
          window.addEventListener('scroll', novicell.debounce(() => {
            novicell.sliderSpot.checkIfVideoIsInViewPort(elements[i], sliderActive, false);
          }, 150), {
            capture: true,
            passive: true
          });
          if (video.classList.contains('js-slider-video-youtube')) {
            window.addEventListener('resize', novicell.debounce(() => {
              novicell.sliderSpot.vidRescale(elements[i]);
            }, 150), true);
          }
        }
      }
    }
  };

  // If in viewport and video is not playing then play it or pause it
  this.checkIfVideoIsInViewPort = function (element, isSlider, youtubeAddPlayerScript) {
    let video = null;
    let youtube = null;
    if (isSlider) {
      video = Flickity.data(element).selectedElement.querySelector('video');
      youtube = Flickity.data(element).selectedElement.querySelector('.js-slider-video-youtube');
    } else {
      video = element.querySelector('video');
      youtube = element.querySelector('.js-slider-video-youtube');
    }
    // Check if we have a youtube element
    if (youtube) {
      // Add youtube api script if it not already exists
      if (youtubeAddPlayerScript && !document.querySelector('#script-youtube-player-api')) {
        let tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/player_api';
        tag.id = 'script-youtube-player-api';
        let lastScriptTag = document.getElementsByTagName('script')[document.getElementsByTagName('script').length - 1];
        lastScriptTag.parentNode.insertBefore(tag, lastScriptTag);
      }
      // Check if youtube is in viewport, then pause it or play it
      let index = youtube.dataset.index;
      if (!youtubeAddPlayerScript && typeof sliderPlayers[index] !== 'undefined' && typeof sliderPlayers[index].getPlayerState === 'function') {
        if (verge.inViewport(element)) {
          if (sliderPlayers[index].getPlayerState() !== 1) {
            sliderPlayers[index].playVideo();
          }
        } else if (sliderPlayers[index].getPlayerState() === 1) {
          sliderPlayers[index].pauseVideo();
        }
      }
      return youtube;
    } else if (video) {
      if (verge.inViewport(element)) {
        if (video.paused) {
          video.play();
          video.addEventListener('playing', () => {
            let video_parent = video.parentNode;
            if (!video_parent.classList.contains('active')) {
              video_parent.classList.add('active');
            }
          });
        }
      } else if (!video.paused) {
        video.pause();
      }
      return video;
    }
  };

  // Here we pause all videos
  this.pauseAllVideos = function (flkty, elem) {
    let videos = elem.querySelectorAll('video');
    if (videos.length) {
      for (let i = 0; i < videos.length; i++) {
        let video = videos[i];
        if (!video.paused) {
          video.pause();
        }
      }
    }
    let youtube_videos = elem.querySelectorAll('.js-slider-video-youtube');
    if (youtube_videos.length) {
      for (let i = 0; i < youtube_videos.length; i++) {
        let index = youtube_videos[i].dataset.index;
        if (typeof sliderPlayers[index] !== 'undefined' && typeof sliderPlayers[index].getPlayerState === 'function' && sliderPlayers[index].getPlayerState() === 1) {
          sliderPlayers[index].pauseVideo();
        }
      }
    }
  };

  this.vidRescale = function (element) {
    let youtube_videos = element.querySelectorAll('.js-slider-video-youtube');
    if (youtube_videos.length) {
      for (let i = 0; i < youtube_videos.length; i++) {
        let index = youtube_videos[i].dataset.index;
        let tvScreen = youtube_videos[i].querySelector('.slider-spot__video-tv-screen');
        if (tvScreen != null && typeof sliderPlayers[index] !== 'undefined') {
          let w = window.innerWidth + 200, h = window.innerHeight + 200;
          if (w / h > 16 / 9) {
            sliderPlayers[index].setSize(w, w / 16 * 9);
          } else {
            sliderPlayers[index].setSize(h / 9 * 16, h);
          }
        }
      }
    }
  };

  this.onPlayerReady = function (event, element) {
    event.target.mute();
    if (element) {
      novicell.sliderSpot.vidRescale(element);
      if (verge.inViewport(element)) {
        event.target.playVideo();
      }
    }
  };

  this.onPlayerStateChange = function (event) {
    let id = event.target.getIframe().id.replace('js-slider-video-player-', '');
    if (typeof sliderPlayers[id] !== 'undefined') {
      if (event.data === 1) {
        document.getElementById('js-slider-video-player-' + id).parentNode.classList.add('active');
      } else if (event.data === 0) {
        sliderPlayers[id].seekTo(0);
      }
    }
  };

  this.loadYouTubeVideos = function () {
    const elements = document.querySelectorAll('.js-slider-spot');
    if (elements.length) {
      for (let i = 0; i < elements.length; i++) {
        let youtube_videos = elements[i].querySelectorAll('.js-slider-video-youtube');
        if (youtube_videos.length) {
          YT = window.YT;
          for (let i = 0; i < youtube_videos.length; i++) {
            let index = youtube_videos[i].dataset.index;
            sliderPlayers[index] = new YT.Player('js-slider-video-player-' + index, {
              videoId: youtube_videos[i].dataset.youtubeId,
              playerVars: {
                'autoplay': 0,
                'loop': 1,
                'modestbranding': 1,
                'rel': 0,
                'showinfo': 0,
                'controls': 0,
                'disablekb': 1,
                'enablejsapi': 1,
                'iv_load_policy': 3,
                'origin': window.location.href
              },
              events: {
                'onReady': (event) => {
                  novicell.sliderSpot.onPlayerReady(event, elements[i]);
                },
                'onStateChange': novicell.sliderSpot.onPlayerStateChange
              }
            });
          }
        }
      }
    }
  };
}();